import Sheet from "./Sheet";
import {
  COMPATIBILITY_BANDS, compatibilityBand, RESPONSIVENESS_BANDS, responsivenessBand, scoreColor,
} from "../lib/bands";

/** Ported from DeckView.swift's CompatibilityInfoSheet. */
export function CompatibilityInfoSheet({
  pct, name, open, onClose,
}: {
  pct: number; name: string; open: boolean; onClose: () => void;
}) {
  return (
    <Sheet open={open} onClose={onClose}>
      <div className="center">
        <div className="info-big" style={{ color: scoreColor(pct) }}>{pct}%</div>
        <h2 style={{ margin: "4px 0" }}>Compatibility factor: {compatibilityBand(pct)}</h2>
        <p className="muted" style={{ fontSize: 14 }}>
          How much you and {name} have in common, based on your profiles — your headline,
          bio, and prompt answers. The more your answers overlap, the higher it climbs.
        </p>
      </div>
      <BandTable bands={COMPATIBILITY_BANDS} active={compatibilityBand(pct)} />
      <button className="btn" onClick={onClose}>Got it</button>
    </Sheet>
  );
}

/** Ported from DeckView.swift's ResponsivenessInfoSheet. */
export function ResponsivenessInfoSheet({
  pct, name = "", isSelf = false, open, onClose,
}: {
  pct: number; name?: string; isSelf?: boolean; open: boolean; onClose: () => void;
}) {
  return (
    <Sheet open={open} onClose={onClose}>
      <div className="center">
        <div className="info-big" style={{ color: scoreColor(pct) }}>{pct}</div>
        <h2 style={{ margin: "4px 0" }}>Responsiveness: {responsivenessBand(pct)}</h2>
        <p className="muted" style={{ fontSize: 14 }}>
          {isSelf
            ? "How often you reply after matching. 100 means you get a conversation going with every match; lower means more matches left on read. Reply to your matches to keep it high."
            : `How often ${name} replies after matching. 100 means they get a conversation going with every match; lower means they leave more matches on read.`}
        </p>
      </div>
      <BandTable bands={RESPONSIVENESS_BANDS} active={responsivenessBand(pct)} />
      <button className="btn" onClick={onClose}>Got it</button>
    </Sheet>
  );
}

function BandTable({ bands, active }: { bands: { label: string; range: string }[]; active: string }) {
  return (
    <div className="band-table">
      {bands.map((b) => (
        <div key={b.label} className={"band-row" + (b.label === active ? " band-active" : "")}>
          <span>{b.label}</span>
          <span className="muted">{b.range}</span>
        </div>
      ))}
    </div>
  );
}
